module.exports = __webpack_public_path__ + "static/media/connor-sampson.5e85a8c3.png";